import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { getInputClasses } from '../Input/util.js';

const Textarea = /*#__PURE__*/forwardRef(function Textarea(props, ref) {
  const {
    defaultValue: _,
    highlighted,
    invalid,
    onKeyDown,
    ...otherProps
  } = props;
  const classNames = cn(getInputClasses(props), 'py-1 min-h-[75px] disabled:resize-none', props.className); // home and end keys only navigate to the start/end of textarea value if the textarea container does not scroll
  // if it has scroll height then the browser reverts to native scrolling behaviour only
  // so we manually override it to ensure _our_ desired behaviour remains intact

  const handleKeyDown = event => {
    if (event.key === 'Home' || event.key === 'End') {
      event.preventDefault();
      const position = event.key === 'End' ? event.currentTarget.value.length : 0;
      event.currentTarget.setSelectionRange(position, position);
      event.currentTarget.scrollTop = event.key === 'End' ? event.currentTarget.scrollHeight : 0;
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  return createElement("textarea", Object.assign({}, otherProps, {
    className: classNames,
    "data-taco": "textarea",
    onKeyDown: handleKeyDown,
    ref: ref
  }));
});

export { Textarea };
//# sourceMappingURL=Textarea.js.map
